//Imports
import './DeckNav.css';
import "../Homepage/Home.css";
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function DeckNav({ faceCard = [], title_input }) {

  const [showPopup, setShowPopup] = useState(false);

  const handleClick = (card) => {
    if (card.comingSoon) {
      setShowPopup(true);
      return;
    }
    window.location.href = card.Link;
  };

  return (
    <div>
      <div>
        <h1 className="subheader-nav">{title_input}</h1>
      </div>

      <div className="CardContainer-nav">
        {faceCard.map((a) => (
          <div
            key={a.id}
            className="Card-nav"
            id={a.id}
            onClick={() => handleClick(a)}
          >
            {!a.comingSoon ? (
              <Link to={a.Link}>
                <img src={a.Image} alt={a.Title} className="CardImage-nav" />
                <h3 id={a.cssId} className="cardTitle-nav">{a.Title}</h3>
                <div className="CardDifficulty-nav">{a.Difficulty}</div>
                <p className="cardDescription-nav">{a.Description}</p>
              </Link>
            ) : (
              <>
                <img src={a.Image} alt={a.Title} className="CardImage-nav" />
                <h3 id={a.cssId} className="cardTitle-nav">{a.Title}</h3>
                <div className="CardDifficulty-nav">{a.Difficulty}</div>
                <p className="cardDescription-nav">{a.Description}</p>
              </>
            )}
          </div>
        ))}
      </div>

      {/* Popup: Coming Soon */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>Coming Soon!</h3>
            <p>This content is not available yet.</p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
}
